import { useState, useEffect } from 'react'
import CreativeComponent from "components/atoms/CreativeComponent";
import QRCode from 'components/atoms/QRCode';
import FlipIcon from 'components/atoms/FlipIcon';
import PhonePortrait from 'assets/iphone.png';
import PhoneLandscape from 'assets/iphone-landscape.png';
import { CreativeType, CreativeMetaData, DisplayBannerT } from "types/creative";
import { setCreativeViewSize } from 'context/actions';
import { useAppState, useAppDispatch } from "context";
import { PLAYBACK_TYPE } from 'services/constants'
import { getCreativeDimensions, getPlaybackName } from 'services/utils';

import "./MobileView.scss";

type opts = {
  width?: number | string,
  height?: number | string,
}

const MobileView = () => {
  const dispatch = useAppDispatch();
  const [isPortrait, setIsPortrait] = useState(true);
  const { creative = {} as CreativeType, activeCreativeView, displayBanner = {} as DisplayBannerT } = useAppState();
  const { active: activeBanner, size: { width: bannerWidth, height: bannerHeight } } = displayBanner;
  const { width, height } = activeCreativeView;
  const { media_asset: { metadata = {} as CreativeMetaData } = {}, media_type, playback_id } = creative;
  const { aspect_ratio = 1.5 } = metadata;
  const isVerticalCreative = aspect_ratio < 1;
  const isSocial = creative.playback_id === PLAYBACK_TYPE.social;
  const isTikTok = creative.playback_id === PLAYBACK_TYPE.tiktok;
  const showText = isPortrait && (!isSocial && !isTikTok)
  const cssOrientation = `mobile-view-${isPortrait ? 'portrait' : 'landscape'}`
  const videoControls = media_type === 1 && (playback_id === PLAYBACK_TYPE.shop || playback_id === PLAYBACK_TYPE.maxo3 || playback_id === PLAYBACK_TYPE.lite) && !activeBanner
  const cssClass = `${(isSocial || isTikTok) ? 'blank-page' : `${showText ? 'text-page' : 'blank-page'}`}`
  const allowRotate = !isVerticalCreative && !isSocial && !isTikTok;
  const playbackClass = getPlaybackName(creative.playback_id);

  useEffect(() => {
    return () => {
      dispatch(setCreativeViewSize({ width, height }));
    }
  }, [])

  // handle changes here
  useEffect(() => {
    if (activeBanner) {
      dispatch(setCreativeViewSize(displayBanner.size));
    } else {
      // if use full screen
      if (isSocial) {
        dispatch(setCreativeViewSize({ width: '100%', height: '100%' }));
      } else { // all other playbacks adjust
        if (!isPortrait) {
          const size = getCreativeDimensions(creative, null, 354);
          dispatch(setCreativeViewSize(size));
        } else {
          const size = getCreativeDimensions(creative, 380, null);
          dispatch(setCreativeViewSize(size))
        }
      }
    }
  }, [activeBanner, bannerWidth, bannerHeight, videoControls, isPortrait])

  const onClickHandle = () => {
    setIsPortrait(!isPortrait);
  }
  return (
    <div className={`mobile-view-container ${cssOrientation}`}>
      <div className="phone-and-rotate-icon">
        {allowRotate && <FlipIcon onClick={onClickHandle} width={50} />}
        <div className="phone-container">
          <div className={`screen-web-page ${cssClass} ${playbackClass} ${activeBanner ? 'banner' : ''}`}>

            {showText &&
              <div className="lorem-text">
                <h2>Lorem Ipsum</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nec velit laoreet, feugiat ex cursus, dignissim orci. Praesent sollicitudin nisi arcu, in tincidunt enim finibus et. Fusce dictum nulla nec nibh facilisis, ac vehicula diam euismod. Vivamus ultricies vulputate sapien a posuere. Etiam sagittis hendrerit urna, a ornare mi aliquet sit amet. Mauris quis pharetra lacus, non pretium turpis. Duis sit amet pulvinar dui. Quisque efficitur ultrices metus, nec placerat massa placerat vitae. In ut tortor a elit sagittis tincidunt eget nec dui. Donec nec tincidunt diam. Nam vel hendrerit nibh. Vivamus nec ullamcorper nunc, eu venenatis mi. Morbi gravida varius urna ac dictum.</p>
                <CreativeComponent videoControls={videoControls} className={'mobile-creative'} />
                <p>In eu feugiat mauris. Suspendisse viverra orci eu dolor interdum, non viverra ante consequat. Sed varius gravida nisi in tempor. Vivamus varius nec mauris ut tempor. Aliquam arcu purus, malesuada eu placerat quis, ullamcorper ac dui. Proin turpis est, tristique nec massa eget, facilisis vestibulum ipsum. Integer sit amet efficitur lorem. Morbi lacinia velit sit amet risus molestie, nec malesuada libero porttitor. Cras quis erat ligula. Aenean sollicitudin ut nisi et blandit. Proin ultricies erat a augue aliquam, vel placerat nisl volutpat. Aliquam erat volutpat. Etiam aliquet nisl et iaculis luctus. Maecenas malesuada ultrices tempus. Vivamus sed elit lobortis dui sodales accumsan vestibulum quis velit. </p>
                <p> Maecenas congue augue aliquet, malesuada urna non, vestibulum nulla. Phasellus ultrices metus ut pretium auctor. Curabitur sit amet libero vitae ante congue scelerisque. Cras sodales id diam sit amet fermentum. Duis iaculis justo faucibus pellentesque vulputate. Nam at dui fermentum, volutpat purus pellentesque, imperdiet nulla. Donec ultricies dolor sapien, et luctus urna consectetur id. Nam at posuere sapien. Aliquam erat volutpat.</p>
                <p>Morbi at ex in arcu semper condimentum. Nunc eleifend blandit sodales. Cras non sagittis quam. Cras lacus nisl, ullamcorper vitae dui non, sodales pulvinar risus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus pharetra sem nibh, eu convallis diam pellentesque ut. Vivamus lobortis augue sed dolor ullamcorper varius. Integer hendrerit enim sit amet varius egestas. Morbi non placerat ipsum. Curabitur pharetra pharetra ligula vel pretium. Nullam facilisis quam molestie convallis lacinia. Morbi scelerisque dolor venenatis, lacinia nibh et, vestibulum sem. </p>
              </div>
            }
            {!showText && <CreativeComponent videoControls={videoControls} className={'mobile-creative'} />}

          </div>
          <div className="phone" style={{ backgroundImage: `url(${isPortrait ? PhonePortrait : PhoneLandscape})` }}></div>

        </div>

      </div>
      <div className="code-and-message">
        <QRCode></QRCode>
        <span className="scan-with-phone-txt">
          Scan with phone camera to load on mobile device
        </span>
      </div>
    </div>
  );
};

export default MobileView;
